import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GameThumbnailPipe} from '../../../pipes/game-thumbnail.pipe';
import {ProgressBarStarsComponent} from '../../progress/progress-bar-stars/progress-bar-stars.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-game-item',
  standalone: true,
  imports: [
    CommonModule,
    GameThumbnailPipe,
    ProgressBarStarsComponent,
    TranslateModule
  ],
  templateUrl: './game-item.component.html',
  styleUrls: ['./game-item.component.scss']
})
export class GameItemComponent implements OnInit {

  @Input() game: any;
  @Output() open: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  openGame() {
    this.open.emit();
  }

}
